var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAItech(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3333C18.0008 13.0666 17.9482 12.8025 17.8455 12.5565C17.7427 12.3104 17.5917 12.0874 17.4015 11.9006C17.2113 11.7137 16.9856 11.5668 16.7378 11.4684C16.4899 11.3701 16.2249 11.3223 15.9583 11.3278C15.6917 11.3334 15.429 11.3922 15.1854 11.5008C14.9419 11.6094 14.7225 11.7656 14.5403 11.9602C14.358 12.1548 14.2165 12.3839 14.124 12.6341C14.0316 12.8842 13.9901 13.1502 14.002 13.4166C13.6101 13.5174 13.2463 13.706 12.9382 13.9682C12.63 14.2303 12.3855 14.5592 12.2232 14.9299C12.061 15.3005 11.9852 15.7032 12.0016 16.1075C12.018 16.5118 12.1262 16.907 12.318 17.2633C11.9808 17.5372 11.7156 17.8894 11.5456 18.2892C11.3755 18.689 11.3057 19.1243 11.3422 19.5573C11.3788 19.9902 11.5205 20.4077 11.7552 20.7733C11.9899 21.1389 12.3103 21.4417 12.6887 21.6553C12.6419 22.0168 12.6698 22.384 12.7706 22.7343C12.8714 23.0846 13.0429 23.4105 13.2745 23.6919C13.5062 23.9733 13.7931 24.2043 14.1175 24.3705C14.4419 24.5367 14.7969 24.6346 15.1606 24.6582C15.5244 24.6818 15.8891 24.6306 16.2323 24.5077C16.5754 24.3848 16.8898 24.1929 17.1558 23.9438C17.4219 23.6947 17.6341 23.3937 17.7793 23.0593C17.9245 22.725 17.9996 22.3644 18 22V13.3333Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3333C17.9992 13.0666 18.0518 12.8025 18.1545 12.5565C18.2573 12.3104 18.4083 12.0874 18.5985 11.9006C18.7887 11.7137 19.0144 11.5668 19.2622 11.4684C19.5101 11.3701 19.7751 11.3223 20.0417 11.3278C20.3083 11.3334 20.5711 11.3922 20.8146 11.5008C21.0581 11.6094 21.2775 11.7656 21.4597 11.9602C21.642 12.1548 21.7835 12.3839 21.876 12.6341C21.9684 12.8842 22.0099 13.1502 21.998 13.4166C22.3899 13.5174 22.7537 13.706 23.0619 13.9682C23.37 14.2303 23.6145 14.5592 23.7768 14.9299C23.939 15.3005 24.0148 15.7032 23.9984 16.1075C23.982 16.5118 23.8738 16.907 23.682 17.2633C24.0192 17.5372 24.2844 17.8894 24.4545 18.2892C24.6245 18.689 24.6943 19.1243 24.6578 19.5573C24.6212 19.9902 24.4795 20.4077 24.2448 20.7733C24.0101 21.1389 23.6897 21.4417 23.3113 21.6553C23.3581 22.0168 23.3302 22.384 23.2294 22.7343C23.1287 23.0846 22.9571 23.4105 22.7255 23.6919C22.4938 23.9733 22.2069 24.2043 21.8825 24.3705C21.5581 24.5367 21.2031 24.6346 20.8394 24.6582C20.4756 24.6818 20.1109 24.6306 19.7678 24.5077C19.4246 24.3848 19.1103 24.1929 18.8442 23.9438C18.5781 23.6947 18.3659 23.3937 18.2207 23.0593C18.0755 22.725 18.0004 22.3644 18 22V13.3333Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6667C19.4403 18.4698 18.9515 18.1113 18.5956 17.6367C18.2396 17.162 18.0323 16.5924 18 16C17.9677 16.5924 17.7604 17.162 17.4044 17.6367C17.0485 18.1113 16.5597 18.4698 16 18.6667",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7327 14.3333C21.894 14.0537 21.9853 13.7392 21.9987 13.4166",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 13.4166C14.0152 13.7391 14.1062 14.0536 14.2673 14.3333",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.318 17.264C12.44 17.1647 12.5705 17.0763 12.708 17",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.292 17C23.4295 17.0763 23.56 17.1647 23.682 17.264",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C13.5405 22.0002 13.0888 21.8817 12.6887 21.656",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3113 21.656C22.9112 21.8817 22.4594 22.0002 22 22",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAItech);
export default __webpack_public_path__ + "static/media/AItech.1d7619befa95e11bc1aecbce42608986.svg";
export { ForwardRef as ReactComponent };